<mat-tab-group>
    <!-- Buttons -->
    <mat-tab label="Buttons">
        <ng-template matTabContent>
            <div class="p-4 flex flex-col gap-8">
                <h1 class="text-4xl font-bold">Buttons</h1>
                <buttons-storybook></buttons-storybook>
            </div>
        </ng-template>
    </mat-tab>

    <!-- Toggle Buttons -->
    <mat-tab label="Toggle Buttons">
        <ng-template matTabContent>
            <div class="p-4 flex flex-col gap-8">
                <h1 class="text-4xl font-bold">Toggle Buttons</h1>
                <button-toggle-storybook></button-toggle-storybook>
            </div>
        </ng-template>
    </mat-tab>

    <!-- Avatar -->
    <mat-tab label="Avatar">
        <ng-template matTabContent>
            <div class="p-4 flex flex-col gap-8">
                <h1 class="text-4xl font-bold">Avatar</h1>
                <avatar-storybook></avatar-storybook>
            </div>
        </ng-template>
    </mat-tab>

    <!-- Dropdown -->
    <mat-tab label="Dropdown">
        <ng-template matTabContent>
            <div class="p-4 flex flex-col gap-8">
                <h1 class="text-4xl font-bold">Dropdown</h1>
                <dropdown-storybook></dropdown-storybook>
            </div>
        </ng-template>
    </mat-tab>

    <!-- Form Field -->
    <mat-tab label="Form Field">
        <ng-template matTabContent>
            <div class="p-4 flex flex-col gap-8">
                <h1 class="text-4xl font-bold">Form Field</h1>
                <form-field-storybook></form-field-storybook>
            </div>
        </ng-template>
    </mat-tab>

    <!-- Chips -->
    <mat-tab label="Chips">
        <ng-template matTabContent>
            <div class="p-4 flex flex-col gap-8">
                <h1 class="text-4xl font-bold">Chips</h1>
                <chip-storybook></chip-storybook>
            </div>
        </ng-template>
    </mat-tab>

    <!-- Switches -->
    <mat-tab label="Switches">
        <ng-template matTabContent>
            <div class="p-4 flex flex-col gap-8">
                <h1 class="text-4xl font-bold">Switches</h1>
                <mat-slide-toggle class="v2-mdc-switch small">Small</mat-slide-toggle>
                <mat-slide-toggle class="v2-mdc-switch medium">Medium</mat-slide-toggle>
                <mat-slide-toggle class="v2-mdc-switch large">Large</mat-slide-toggle>

                <mat-slide-toggle class="v2-mdc-switch small" [disabled]="true">Small</mat-slide-toggle>
                <mat-slide-toggle class="v2-mdc-switch medium" [disabled]="true">Medium</mat-slide-toggle>
                <mat-slide-toggle class="v2-mdc-switch large" [disabled]="true">Large</mat-slide-toggle>
            </div>
        </ng-template>
    </mat-tab>

    <!-- Radio -->
    <mat-tab label="Radio">
        <ng-template matTabContent>
            <h3>Radio Button</h3>
            <div class="flex flex-col gap-4">
                <mat-radio-button>Normal</mat-radio-button>
                <mat-radio-button checked>Checked</mat-radio-button>
                <mat-radio-button disabled>Disabled</mat-radio-button>
            </div>

            <mat-radio-button checked disabled>Disabled + Checked</mat-radio-button>
        </ng-template>
    </mat-tab>

    <!-- Checkbox -->
    <mat-tab label="Checkbox">
        <ng-template matTabContent>
            <h3>Checkbox</h3>
            <div class="flex flex-col gap-4">
                <mat-checkbox>Normal</mat-checkbox>
                <mat-checkbox checked>Checked</mat-checkbox>
                <mat-checkbox disabled>Disabled</mat-checkbox>
                <mat-checkbox checked disabled>Disabled + Checked</mat-checkbox>

                <mat-checkbox class="select-all" [indeterminate]="true"> Indeterminate </mat-checkbox>
                <mat-checkbox class="select-all" [indeterminate]="true" disabled>
                    Indeterminate + Disabled
                </mat-checkbox>
            </div>
        </ng-template>
    </mat-tab>

    <!-- Progress -->
    <mat-tab label="Progress">
        <ng-template matTabContent>
            <div class="p-4 flex flex-col gap-8">
                <h1 class="text-4xl font-bold">Progress</h1>
                <progress-storybook></progress-storybook>
            </div>
        </ng-template>
    </mat-tab>

    <!-- Alert -->
    <mat-tab label="Alert">
        <ng-template matTabContent>
            <div class="p-4 flex flex-col gap-8">
                <h1 class="text-4xl font-bold">Alert</h1>
                <alert-storybook></alert-storybook>
            </div>
        </ng-template>
    </mat-tab>

    <!-- Paginator -->
    <mat-tab label="Paginator">
        <ng-template matTabContent>
            <h3>Paginator</h3>
            <paginator-storybook></paginator-storybook>
        </ng-template>
    </mat-tab>

    <!-- Datepicker -->
    <mat-tab label="Datepicker">
        <ng-template matTabContent>
            <div class="p-4 flex flex-col gap-8">
                <h3 class="text-4xl font-bold">Datepicker</h3>
                <datepicker-storybook></datepicker-storybook>
            </div>
        </ng-template>
    </mat-tab>
</mat-tab-group>